var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { createHashHistory } from "history";
import { maxDirectoryTraversalDepth } from "./constants";
export var history = createHashHistory();
var DateFormatter = new Intl.DateTimeFormat(undefined, {
    year: "numeric",
    month: "numeric",
    day: "numeric",
    hour: "numeric",
    minute: "numeric",
    hour12: true,
});
// Function that takes in a string representation of a date and returns an Internationalized date string
export var formatDate = function (date) {
    try {
        return DateFormatter.format(new Date(date));
    }
    catch (err) {
        return "-";
    }
};
// A promise wrapper around FileSystemDirectoryReader.readEntries
export var readEntries = function (reader) {
    return new Promise(function (resolve, reject) {
        reader.readEntries(function (entries) {
            // https://developer.mozilla.org/en-US/docs/Web/API/FileSystemDirectoryReader
            var fsEntries = entries;
            resolve(fsEntries);
        }, function (error) {
            reject(error);
        });
    });
};
export function isFileSystemFileEntry(file) {
    return file.isFile;
}
export function isFileSystemDirectoryEntry(file) {
    return Boolean(file === null || file === void 0 ? void 0 : file.isDirectory);
}
// A promise wrapper around FileSystemFileEntry.file
export var readFileFromEntry = function (entry) {
    return new Promise(function (resolve, reject) {
        entry.file(function (file) {
            resolve(file);
        }, function (error) {
            reject(error);
        });
    });
};
export var readDirectory = function (directory, fileTraversalStateManager, depth) {
    if (depth === void 0) { depth = 0; }
    return __awaiter(void 0, void 0, void 0, function () {
        var reader, entries, i, entry, file;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (depth > maxDirectoryTraversalDepth) {
                        return [2 /*return*/, []];
                    }
                    reader = directory.createReader();
                    return [4 /*yield*/, readEntries(reader)];
                case 1:
                    entries = _a.sent();
                    i = 0;
                    _a.label = 2;
                case 2:
                    if (!(i < entries.length)) return [3 /*break*/, 7];
                    entry = entries[i];
                    if (!isFileSystemFileEntry(entry)) return [3 /*break*/, 4];
                    return [4 /*yield*/, readFileFromEntry(entry)];
                case 3:
                    file = _a.sent();
                    fileTraversalStateManager.addFile({ path: entry.fullPath, file: file });
                    return [3 /*break*/, 6];
                case 4:
                    if (!isFileSystemDirectoryEntry(entry)) return [3 /*break*/, 6];
                    fileTraversalStateManager.addFolder({ path: entry.fullPath });
                    return [4 /*yield*/, readDirectory(entry, fileTraversalStateManager, depth + 1)];
                case 5:
                    _a.sent();
                    _a.label = 6;
                case 6:
                    i++;
                    return [3 /*break*/, 2];
                case 7: return [2 /*return*/];
            }
        });
    });
};
// Concatenate two paths
export var concatenatePaths = function (path1, path2) {
    // Remove trailing slash from path1 if it exists
    if (path1.endsWith("/")) {
        path1 = path1.slice(0, -1);
    }
    // Remove leading slash from path2 if it exists
    if (path2.startsWith("/")) {
        path2 = path2.slice(1);
    }
    // Concatenate the paths
    return "".concat(path1, "/").concat(path2);
};
